<template>
  <div>
    <ul class="nav-tabs">
      <li :key="key" v-for="{ disabled, key, name } in tabList" :class="{ disabled, active: key == selectedTab }">
        <a
          @click="
            if (!disabled) {
              selectedTab = key
            }
          "
          >{{ name }}</a
        >
      </li>
    </ul>

    <div class="tab-content">
      <div :key="key" v-for="({ key }, i) in tabList">
        <slot :name="`tab-${i}`" v-if="key == selectedTab" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    selectedTab: null,
  }),
  props: {
    tabList: {
      type: Array,
      required: true,
      validator: prop =>
        prop.every(e => Object.hasOwn(e, 'disabled') && Object.hasOwn(e, 'key') && Object.hasOwn(e, 'name')),
    },
  },
  mounted() {
    this.selectedTab = this.tabList.find(({ disabled }) => !disabled)?.key
  },
}
</script>

<style lang="scss" scoped>
.nav-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.75rem;
  border-bottom: none;
  li {
    display: inline-block;
    a {
      cursor: pointer;
      padding: 0 0 0.5rem 0;
      color: var(--primary-font-color);
      &:hover {
        opacity: 0.8;
      }
    }
    &.active {
      border-bottom: 2px solid #269a6c;
      a {
        color: #269a6c;
        font-weight: 600;
      }
    }
    &.disabled {
      a {
        cursor: not-allowed;
        color: #b3b5b2;
      }
    }
  }
}
</style>
